import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "admin-dashboard"
    }}>{`Admin dashboard`}</h1>
    <ul>
      <li parentName="ul">
        <h2 parentName="li" {...{
          "id": "analytics-dashboard"
        }}>{`Analytics Dashboard`}</h2>
      </li>
    </ul>
    <p>{`You will get a complete analytics dashboard to know the overview of your shop.`}</p>
    <p><img alt="widgets" src={require("../images/small-cards.png")} />{`
`}<img alt="sales-history" src={require("../images/sales-history.png")} />{`
`}<img alt="recent-orders" src={require("../images/recent-orders.png")} />{`
`}<img alt="popular-products" src={require("../images/popular-products.png")} /></p>
    <ul>
      <li parentName="ul">
        <h2 parentName="li" {...{
          "id": "manage-product-type"
        }}>{`Manage Product Type`}</h2>
        <p parentName="li">{`In `}<inlineCode parentName="p">{`Types`}</inlineCode>{` menu you will get the product types and you can add, remove or modify product type from there.`}</p>
        <p parentName="li"><img alt="type-list" src={require("../images/type-list.png")} /></p>
      </li>
      <li parentName="ul">
        <h2 parentName="li" {...{
          "id": "manage-product-category"
        }}>{`Manage Product Category`}</h2>
        <p parentName="li">{`In `}<inlineCode parentName="p">{`Categories`}</inlineCode>{` menu you will get the product types and you can add, remove or modify product categories from there.`}</p>
        <p parentName="li"><img alt="category-list" src={require("../images/category-list.png")} /></p>
      </li>
      <li parentName="ul">
        <h2 parentName="li" {...{
          "id": "product-management"
        }}>{`Product Management`}</h2>
        <p parentName="li">{`In `}<inlineCode parentName="p">{`Products`}</inlineCode>{` menu you will get the products and you can add, remove or modify products from there.`}</p>
        <p parentName="li"><img alt="product-list" src={require("../images/product-list.png")} /></p>
        <h3 parentName="li" {...{
          "id": "a-portion-of-product-form"
        }}>{`A portion of product form`}</h3>
        <p parentName="li"><img alt="product-form" src={require("../images/product-form.png")} /></p>
      </li>
      <li parentName="ul">
        <h2 parentName="li" {...{
          "id": "order-status"
        }}>{`Order Status`}</h2>
        <p parentName="li">{`In `}<inlineCode parentName="p">{`Order Status`}</inlineCode>{` menu you will get the order status list and you can add, remove or modify order status from there.`}</p>
        <p parentName="li"><img alt="orderstatus-list" src={require("../images/orderstatus-list.png")} /></p>
        <h1 parentName="li" {...{
          "id": "order-management"
        }}>{`Order Management`}</h1>
        <p parentName="li">{`In `}<inlineCode parentName="p">{`Order`}</inlineCode>{` menu you will get the order list and you can add, remove or modify order from there.`}</p>
        <p parentName="li"><img alt="order-list" src={require("../images/order-list.png")} /></p>
      </li>
    </ul>
    <h3 {...{
      "id": "a-portion-of-order-management-order-status-change"
    }}>{`A portion of order management. Order status change.`}</h3>
    <p><img alt="order-change-status" src={require("../images/order-change-status.png")} /></p>
    <h2 {...{
      "id": "coupon-management"
    }}>{`Coupon Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`Coupon`}</inlineCode>{` menu you will get the Coupon list and you can add, remove or modify Coupon from there.`}</p>
    <p><img alt="coupon-list" src={require("../images/coupon-list.png")} /></p>
    <h2 {...{
      "id": "customer-management"
    }}>{`Customer Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`Customer`}</inlineCode>{` menu you will get the Customer list and you can add, remove or modify Customer from there.`}</p>
    <p><img alt="customer" src={require("../images/customer.png")} /></p>
    <h2 {...{
      "id": "tax-management"
    }}>{`Tax Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`Tax`}</inlineCode>{` menu you will get the Tax list and you can add, remove or modify Tax from there.`}</p>
    <p><img alt="tax-list" src={require("../images/tax-list.png")} /></p>
    <h2 {...{
      "id": "shipping-management"
    }}>{`Shipping Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`shipping`}</inlineCode>{` menu you will get the shipping list and you can add, remove or modify shipping from there.`}</p>
    <p><img alt="shipping-list" src={require("../images/shipping-list.png")} /></p>
    <h2 {...{
      "id": "shipping-management-1"
    }}>{`Shipping Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`shipping`}</inlineCode>{` menu you will get the shipping list and you can add, remove or modify shipping from there.`}</p>
    <p><img alt="shipping-list" src={require("../images/shipping-list.png")} /></p>
    <h2 {...{
      "id": "settings-management"
    }}>{`Settings Management`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`settings`}</inlineCode>{` menu you will get the settings management form there.`}</p>
    <p><img alt="settings-1" src={require("../images/settings-1.png")} /></p>
    <p><img alt="settings" src={require("../images/settings.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      